import { Button, ColorPicker, Select, Slider } from "antd";
import { memo, useEffect, useMemo, useState } from "react";
import { useAtom } from 'jotai';
import styled from "styled-components";
import { selectedMapDataAtom, } from "~/components/Map/stores/mapStore";
import StyleCircle from "./components/StyleCircle";
import StyleFill from "./components/StyleFill";
import StyleLine from "./components/StyleLine";
import StyleSymbol from "./components/StyleSymbol";
import { MAP_DATA_LAYER_ID_PREFIX, MAP_DATA_SOURCE_ID_PREFIX } from "~/components/Map/utils/MapDataUtils";

const StyleTab = () => {
  const [selectedMapData, setSelectedMapData] = useAtom(selectedMapDataAtom);

  const [showCreateNewLayer, setShowCreateNewLayer] = useState(false);
  const [createNewLayerName, setCreateNewLayerName] = useState('');
  const [createNewLayerType, setCreateNewLayerType] = useState<'Điểm' | 'Đường' | 'Vùng' | 'Nhãn'>('Điểm');

  const [style, setStyle] = useState<any>(null);

  const fetchStyle = () => {
    const map = window.map;
    if (!selectedMapData) return;
    const sourceId = MAP_DATA_SOURCE_ID_PREFIX + selectedMapData.id;
    let style: any = {
      layers: []
    };
    console.log('sourceId', sourceId);

    map?.getStyle()?.layers.forEach((layer: any) => {
      if (layer.source === sourceId) {
        style.layers.push(layer);
      }
    })
    setStyle(style);
  }

  useEffect(() => {
    fetchStyle();
  }, [selectedMapData]);

  const gdalInfo = useMemo(() => {
    try {
      const metadata = JSON.parse(selectedMapData?.metadata || '{}');
      if (metadata.gdalinfo) {
        return JSON.parse(metadata.gdalinfo);
      } else {
        return null;
      }
    } catch (error) {
      return null;
    }
  }, [selectedMapData]);

  const ogrInfo = useMemo(() => {
    try {
      const metadata = JSON.parse(selectedMapData?.metadata || '{}');
      if (metadata.ogrinfo) {
        const parsedOgrinfo = JSON.parse(metadata.ogrinfo);
        setCreateNewLayerName(parsedOgrinfo.layers[0].name);
        return parsedOgrinfo;
      } else {
        return null;
      }
    } catch (error) {
      console.log('error', error);
      return null;
    }
  }, [selectedMapData]);

  const handleCreateNewLayer = () => {
    let newLayer: any = {
      type: 'circle',
      source: MAP_DATA_SOURCE_ID_PREFIX + selectedMapData?.id,
      'source-layer': createNewLayerName,
      layout: {},
      paint: {},
    };
    if (createNewLayerType === 'Vùng') {
      newLayer.paint = {
        'fill-color': 'cyan',
        'fill-opacity': 0.5,
      };
      newLayer.type = 'fill';
      newLayer.filter = ['==', '$type', 'Polygon'];
    } else if (createNewLayerType === 'Đường') {
      newLayer.paint = {
        'line-color': 'yellow',
        'line-opacity': 0.5,
        'line-width': 0.1,
      };
      newLayer.type = 'line';
    } else if (createNewLayerType === 'Điểm') {
      newLayer.paint = {
        'circle-color': 'red',
        'circle-opacity': 0.5,
        'circle-radius': 1,
      };
      newLayer.type = 'circle';
      newLayer.filter = ['==', '$type', 'Point'];
    } else if (createNewLayerType === 'Nhãn') {
      newLayer.id = `${MAP_DATA_LAYER_ID_PREFIX}${style.layers.length}-label`;
      newLayer.layout = {
        'text-field': ['get', ''],
        'text-size': 12,
      }
      newLayer.paint = {
        'text-color': 'white',
        'text-opacity': 1,
        'text-halo-color': 'black',
        'text-halo-width': 1,
      };
      newLayer.type = 'symbol';
      window.map?.addLayer(newLayer);
    }

    const temporaryStyle = JSON.parse(JSON.stringify(style));
    temporaryStyle.layers.push(newLayer);
    setStyle(temporaryStyle);
  }

  return (
    <UI_Wrapper>
      {style?.layers?.map((layer: any, index: number) => {
        if (layer.type === 'circle') {
          return (
            <div key={index}>
              <StyleCircle layer={layer} onDeleted={() => {
                const temporaryStyle = JSON.parse(JSON.stringify(style));
                temporaryStyle.layers = temporaryStyle.layers.filter((l: any) => l.id !== layer.id);
                setStyle(temporaryStyle);
              }} />
              <UI_Divider />
            </div>
          )
        } else if (layer.type === 'symbol') {
          console.log('Nhãn', ogrInfo);
          const fields: any[] = [];
          if (ogrInfo) {
            ogrInfo.layers.forEach((layer: any) => {
              layer.fields.forEach((field: any) => {
                fields.push(field);
              })
            })
          }

          return (
            <div key={index}>
              <StyleSymbol layer={layer} fields={fields} />
              <UI_Divider />
            </div>
          )
        } else if (layer.type === 'fill') {
          return (
            <div key={index}>
              <StyleFill layer={layer} />
              <UI_Divider />
            </div>
          )
        } else if (layer.type === 'line') {
          return (
            <div key={index}>
              <StyleLine layer={layer} />
              <UI_Divider />
            </div>
          )
        }
      })}

      <>
        <UI_Add_New_Wrapper>
          {showCreateNewLayer && (
            <>
              <UI_Label>Chọn lớp</UI_Label>
              <Select style={{ marginRight: 8, width: '100%', marginBottom: 8 }} value={createNewLayerName} onChange={(value) => { setCreateNewLayerName(value) }}>
                {ogrInfo?.layers.map((layer: any, index: number) => {
                  return (
                    <Select.Option value={layer.name} key={index}>{layer.name}</Select.Option>
                  )
                })}
              </Select>
              <UI_Label>Chọn loại style</UI_Label>
              <Select style={{ marginRight: 8, width: '100%', marginBottom: 16 }} value={createNewLayerType} onChange={(value) => { setCreateNewLayerType(value) }}>
                <Select.Option value='Điểm'>Điểm</Select.Option>
                <Select.Option value='Đường'>Đường</Select.Option>
                <Select.Option value='Vùng'>Vùng</Select.Option>
                <Select.Option value='Nhãn'>Nhãn</Select.Option>
              </Select>
              <Button type='primary' style={{ width: '100%' }} onClick={() => { setShowCreateNewLayer(false); handleCreateNewLayer(); }}>Tạo mới</Button>
            </>
          )}
          {!showCreateNewLayer && (
            <>
              <Button type='link' style={{ width: '100%', paddingBottom: 30 }} onClick={() => { setShowCreateNewLayer(true) }}>Thêm mới style</Button>
            </>
          )}
        </UI_Add_New_Wrapper>
      </>
    </UI_Wrapper>
  );
}

export default memo(StyleTab)

const UI_Wrapper = styled.div`
  overflow-y: auto;
  height: calc(100% - 0px);
`

const UI_Divider = styled.div`
  height: 1px;
  background-color: #f0f0f0;
  width: calc(100% - 16px);
  margin-left: 8px;
`

const UI_Content_Part = styled.div`
  padding: 8px;
`

const UI_Content_Title = styled.div`
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
`

const UI_Content_Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-bottom: 8px;
`
const UI_Content_Row_Label = styled.div`
  font-size: 14px;
  margin-right: 8px;
  color: #666666;
  flex: 1;
`
const UI_Content_Row_Value = styled.div`
  flex: 1;
`

const UI_Label = styled.div`
  font-size: 14px;
  color: #666666;
`

const UI_Add_New_Wrapper = styled.div`
  margin-top: 16px;
  width: 100%;
`